import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";
import { getMonitoringsTaskTrip } from "./logisticMonitoringsTaskTripsActions";

import CookieService from "../shared/services/cookiesService";
import configuration from "../config.json";

const REQUEST_CONNECT_MAP_SIGNALR = "REQUEST_CONNECT_MAP_SIGNALR";
const RESPONSE_CONNECT_MAP_SIGNALR = "RESPONSE_CONNECT_MAP_SIGNALR";
const RESPONSE_FAILURE_CONNECT_MAP_SIGNALR = "RESPONSE_FAILURE_CONNECT_MAP_SIGNALR";

const REQUEST_START_CONNECTION_MAP_SIGNALR = "REQUEST_START_CONNECTION_MAP_SIGNALR";
const RESPONSE_START_CONNECTION_MAP_SIGNALR = "RESPONSE_START_CONNECTION_MAP_SIGNALR";
const REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR = "REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR";
const REQUEST_STOP_CONNECTION_MAP_SIGNALR = "REQUEST_STOP_CONNECTION_MAP_SIGNALR";

const REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR = "REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR";
const RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR = "RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR";
const REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR = "REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR";

const REQUEST_RECIEVE_UNITS_LAST_STATE = "REQUEST_RECIEVE_UNITS_LAST_STATE";
const RESPONSE_RECIEVE_UNITS_LAST_STATE = "RESPONSE_RECIEVE_UNITS_LAST_STATE";
const REQUEST_STOP_RECIEVE_UNITS_LAST_STATE = "REQUEST_STOP_RECIEVE_UNITS_LAST_STATE";

const RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR = "RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR";

const requestRecieveUnitsLastState = () => {
  return {
    type: REQUEST_RECIEVE_UNITS_LAST_STATE,
  };
};

const responseRecieveUnitsLastState = (data) => {
  return {
    type: RESPONSE_RECIEVE_UNITS_LAST_STATE,
    data,
  };
};

const requestStopRecieveUnitsLastState = () => {
  return {
    type: REQUEST_STOP_RECIEVE_UNITS_LAST_STATE,
  };
};

const handleStopRecieveUnitsLastState = (connection) => {
  return (dispatch) => {
    connection.off("RecieveUnitsLastState");
    dispatch(requestStopRecieveUnitsLastState());
  };
};

const responseCloseConnection = () => {
  return {
    type: RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
  };
};

let intervalId = null;
let lastStates = {};

const handleRecieveUnitsLastState = (connection) => {
  return (dispatch) => {
    dispatch(requestRecieveUnitsLastState());

    const recive = () => {
      if (Object.keys(lastStates).length > 0) {
        dispatch(responseRecieveUnitsLastState(lastStates));
        lastStates = {};
      }
    };

    clearInterval(intervalId);
    intervalId = setInterval(recive, 2000);

    connection.on("RecieveUnitsLastState", function (result) {
      lastStates[result.id] = result;
    });

    connection.onclose((error) => {
      if (error !== undefined) {
        dispatch(responseCloseConnection(connection));
      }
    });
  };
};

const REQUEST_RECIEVE_POPUP_NOTIFICATION = "REQUEST_RECIEVE_POPUP_NOTIFICATION";
const REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION = "REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION";

const requestRecievePopupNotification = () => {
  return {
    type: REQUEST_RECIEVE_POPUP_NOTIFICATION,
  };
};

const requestStopRecievePopupNotification = () => {
  return {
    type: REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION,
  };
};

const handleStopRecievePopupNotification = (connection) => {
  return (dispatch) => {
    connection.off("RecieveNotificationControlPoint");
    dispatch(requestStopRecievePopupNotification());
  };
};

const handleRecievePopupNotification = (connection, createNotification) => {
  return (dispatch) => {
    dispatch(requestRecievePopupNotification());

    connection.on("RecieveNotificationControlPoint", function (result) {
      createNotification(result);
    });

    connection.onclose((error) => {
      if (error !== undefined) {
        dispatch(responseCloseConnection(connection));
      }
    });
  };
};

const REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS = "REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS";

const REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS = "REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS";

const requestRecieveTaskTripInformations = () => {
  return {
    type: REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS,
  };
};

const handleRecieveTaskTripInformations = (connection, monitoringTaskTrip) => {
  return (dispatch) => {
    dispatch(requestRecieveTaskTripInformations());

    connection.on("RecieveTaskTripInformations", function (result) {
      const taskTripId = window.location.pathname
        .replace("/logistic/monitorings", "")
        .replace("/", "")
        .replace("settings", "")
        .replace("/", "");

      if (taskTripId !== "" && taskTripId !== "/" && taskTripId === result) {
        dispatch(getMonitoringsTaskTrip({ id: taskTripId }));
      }
    });

    connection.onclose((error) => {
      if (error !== undefined) {
        dispatch(responseCloseConnection(connection));
      }
    });
  };
};

const requestStopRecieveTaskTripInformations = () => {
  return {
    type: REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS,
  };
};

const handleStopRecieveTaskTripInformations = (connection) => {
  return (dispatch) => {
    connection.off("RecieveNotificationControlPoint");
    dispatch(requestStopRecieveTaskTripInformations());
  };
};

const requestConnectLastState = () => {
  return {
    type: REQUEST_CONNECT_MAP_SIGNALR,
  };
};

const responseConnectLastState = (connection) => {
  return {
    type: RESPONSE_CONNECT_MAP_SIGNALR,
    connection,
  };
};
const responseFailureConnectLastState = (error) => {
  return {
    type: RESPONSE_FAILURE_CONNECT_MAP_SIGNALR,
    error,
  };
};

const handleConnectLastState = () => {
  return (dispatch) => {
    dispatch(requestConnectLastState());

    const token = JSON.parse(CookieService.getCookie(configuration.cookieName)).token;
    let connection = new HubConnectionBuilder()
      .withUrl(configuration.baseURL + "/Units/LastStates", {
        transport: HttpTransportType.LongPolling,
        accessTokenFactory: () => token,
      })
      .configureLogging(LogLevel.Information)
      .build();

    connection
      .start()
      .then(() => dispatch(responseConnectLastState(connection)))
      .catch((error) => dispatch(responseFailureConnectLastState(error)));
  };
};

const requestStartConnect = () => {
  return {
    type: REQUEST_START_CONNECTION_MAP_SIGNALR,
  };
};

const responseStartConnect = () => {
  return {
    type: RESPONSE_START_CONNECTION_MAP_SIGNALR,
  };
};

const responseFailureStartConnect = (error) => {
  return {
    type: REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR,
    error: error,
  };
};

const requestStopConnect = (connection) => {
  return {
    type: REQUEST_STOP_CONNECTION_MAP_SIGNALR,
    connection,
  };
};

const handleStopConnect = (connection) => {
  return (dispatch) => {
    connection.stop().then(() => {
      dispatch(requestStopConnect());
    });
  };
};

const handleStartConnection = (connection) => {
  return (dispatch) => {
    dispatch(requestStartConnect());

    connection
      .start()
      .then(() => dispatch(responseStartConnect()))
      .catch((error) => dispatch(responseFailureStartConnect(error)));
  };
};

const requestAddUserToGroup = () => {
  return {
    type: REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR,
  };
};

const responseAddUserToGroup = () => {
  return {
    type: RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR,
  };
};

const responseFailureAddUserToGroup = (error) => {
  return {
    type: REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR,
    error: error,
  };
};

const handleAddUserToGroup = (connection) => {
  return (dispatch) => {
    dispatch(requestAddUserToGroup());

    const cookie = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const companyId = cookie.companyId;
    const isNotPayment = cookie.isNotPayment;

    if (!isNotPayment) {
      connection
        .invoke("AddUserToGroup", companyId)
        .then(() => dispatch(responseAddUserToGroup()))
        .catch((error) => dispatch(responseFailureAddUserToGroup(error)));
    }
  };
};

export {
  requestConnectLastState,
  responseConnectLastState,
  handleConnectLastState,
  REQUEST_CONNECT_MAP_SIGNALR,
  RESPONSE_CONNECT_MAP_SIGNALR,
  RESPONSE_FAILURE_CONNECT_MAP_SIGNALR,
  requestStartConnect,
  responseStartConnect,
  responseFailureStartConnect,
  handleStartConnection,
  handleStopConnect,
  REQUEST_START_CONNECTION_MAP_SIGNALR,
  RESPONSE_START_CONNECTION_MAP_SIGNALR,
  REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR,
  REQUEST_STOP_CONNECTION_MAP_SIGNALR,
  requestAddUserToGroup,
  responseAddUserToGroup,
  responseFailureAddUserToGroup,
  handleAddUserToGroup,
  REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR,
  RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR,
  REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR,
  requestRecieveUnitsLastState,
  responseRecieveUnitsLastState,
  requestStopRecieveUnitsLastState,
  handleStopRecieveUnitsLastState,
  handleRecieveUnitsLastState,
  REQUEST_RECIEVE_UNITS_LAST_STATE,
  RESPONSE_RECIEVE_UNITS_LAST_STATE,
  REQUEST_STOP_RECIEVE_UNITS_LAST_STATE,
  RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
  handleRecievePopupNotification,
  handleStopRecievePopupNotification,
  REQUEST_RECIEVE_POPUP_NOTIFICATION,
  REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION,
  handleRecieveTaskTripInformations,
  handleStopRecieveTaskTripInformations,
  REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS,
  REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS,
};
